import {
	border as B,
	color as C,
	leading as L,
	radii as R,
	space as S,
} from "./primitives";

const textColor = {
	primary: C.charcoal,
	secondary: C.fog,
	invert: C.white,
	feature: C.purple,
	negative: C.watermelon,
};
const surfaceColor = {
	primary: C.chalk,
	secondary: C.white,
	invert: C.purple,
	cta: C.midTeal,
	highlight: C.darkTeal,
};
const borderColor = {
	primary: C.grey,
	secondary: C.chalk,
	invert: C.white,
	cta: C.purple,
	ctaSecondary: C.darkTeal,
	highlight: C.violet,
	dark: C.charcoal,
};
const chartColor = {
	purple100: C.purple,
	purple60: C.purple60,
	teal100: C.darkTeal,
	teal60: C.teal60,
	wine100: C.wine,
	wine60: C.wine60,
	fog100: C.fog,
	fog60: C.fog60,
	lavender100: C.lavender,
	lavender60: C.lavender60,
	sun100: C.sun,
	sun60: C.sun60,
	silver100: C.silver,
	mist100: C.mist,
	mist60: C.mist60,
};

export const color = {
	wireframe1: C.midnight,
	fog: C.fog,
	sand: C.sand,
	grey: C.grey,
	wireframe5: C.ice,
	leaf: C.leaf,
	watermelon: C.watermelon,
	text: textColor,
	surface: surfaceColor,
	border: borderColor,
	chart: chartColor,
};

export const padding = {
	xxl: S.xxl,
	xl: S.xl,
	l: S.l,
	m: S.m,
	s: S.s,
	xs: S.xs,
	xxs: S.xxs,
	none: 0,
};

export const margin = {
	componentMargin: S.xxl,
};

export const radius = {
	full: R.full,
	l: R.l,
	m: R.m,
	s: R.s,
};

export const borderThickness = {
	l: B.l,
	m: B.m,
	s: B.s,
};

const displayLeading = {
	xxl: L.compact,
	xl: L.compact,
	l: L.compact,
	m: L.comfy,
	s: L.comfy,
	xs: L.comfy,
};
const titleLeading = {
	l: L.comfy,
	m: L.comfy,
	s: L.comfy,
};
const bodyLeading = {
	l: L.comfy,
	m: L.spacious,
	s: L.extended,
	xs: L.extended,
};
const labelLeading = {
	l: L.compact,
	m: L.compact,
	s: L.compact,
	xs: L.compact,
};
const ctaLeading = {
	m: L.compact,
	s: L.compact,
};

export const leading = {
	display: displayLeading,
	title: titleLeading,
	body: bodyLeading,
	label: labelLeading,
	cta: ctaLeading,
};

export type Breakpoint = "xs" | "sm" | "md" | "lg" | "xl" | "2xl";

export const breakpoints: Record<Breakpoint, number> = {
	xs: 0,
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
	"2xl": 1536,
};
